import { Pipe, PipeTransform } from '@angular/core';

import { userActiveProductIds } from '../constants/constants';
import { ShowAllProductsSelected } from '../models/show-all-products-selected.interface';

@Pipe({ name: 'hasUserSmwProduct', standalone: true })
export class HasUserSmwProductPipe implements PipeTransform {
  transform(
    section: string,
    areAllProductsSelected: ShowAllProductsSelected,
    userServiceUserData: any,
    productList: any,
    stationType: any
  ): boolean {
    if (areAllProductsSelected[section]) {
      return true;
    }
    const productIds = userActiveProductIds(section, userServiceUserData);
    for (const smwProduct of productList.smw[stationType]) {
      if (productIds.indexOf(smwProduct.id) >= 0) {
        return true;
      }
    }
    return false;
  }
}
